var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0008 31.8685C14.9514 31.8685 12.9859 31.0435 11.5368 29.575C10.0877 28.1066 9.27353 26.1149 9.27353 24.0382C9.27353 20.6105 11.8911 17.8689 14.1929 15.3563L17.0008 12.2927L19.8087 15.3563C22.1105 17.8699 24.7281 20.6114 24.7281 24.0382C24.7281 26.1149 23.914 28.1066 22.4648 29.575C21.0157 31.0435 19.0502 31.8685 17.0008 31.8685Z",
    stroke: "#464555",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.f8b344943eed4db5509b3d9868268e07.svg";
export { ForwardRef as ReactComponent };